import type { RuleHandler } from "../types";
import { setIncludes } from "../setIncludes";

const checkAllSeasonIdsMustMatch: RuleHandler = (context, requirement) => {
  if (
    !setIncludes(
      new Set(requirement.userDrivenAttributes?.seasonIds),
      new Set(context.selection.seasonIds),
      requirement.userDrivenAttributes?.allSeasonIdsMustMatch || false,
    )
  ) {
    return false;
  }

  return true;
};

export { checkAllSeasonIdsMustMatch };
